import ImageVideoSlider from "../Molecules/ImageVideoSlider.js";
import lib from "./../js-lib/lib.js";

const Wistia = {
  resetPlayback: (isVideo) => {
    if (!isVideo) {
      isVideo = lib.qsa("video");
    }

    isVideo.forEach((vid, i) => {
      vid.currentTime = 0;
      vid.muted = true;
      vid.pause();
    });
  },
  render: (state) => {
    if (state.eco.current == "disabled") {
      let videos = document.querySelectorAll("[data-vid]");

      const player = [];
      let vidElem = "";
      let sourceElem = "";

      // Create new Elements for Wistia
      videos.forEach((video, i) => {
        vidElem = document.createElement("div");
        vidElem.className = "wistia_embed wistia_async_" + video.dataset.vid;
        vidElem.dataset.id = i;
        vidElem.style.height = "100%";
        vidElem.style.width = "100%";
        vidElem.setAttribute("webkit-playsinline", true);
        video.dataset.id = i;
        video.appendChild(vidElem);
        player[i] = vidElem;

        if (video.hasAttribute("data-autoplay")) {
          vidElem.setAttribute("autoplay", true);
        }

        vidElem.muted = true;
        vidElem.loop = true;
      });

      // Create new Elements for Wistia
      videos.forEach((videox, i) => {
        window._wq = window._wq || [];
        _wq.push({
          id: videox.dataset.vid,
          options: {
            fitStrategy: "cover",
            playButton: false,
            controlsVisibleOnLoad: false,
            fullscreenButton: false,
            playPauseNotifier: false,
            settingsControl: false,
          },
          onReady: function (video) {
            //player[i] = video;
            video.pause();
            video.muted = true;
            video.mute();

            console.log(videox.querySelector("video"));
            state.videos[i] = videox.querySelector("video");

            ImageVideoSlider.scope(videox.closest(".video-foreground"));
          },
        });
      });

      // Set Wistia Video Defaults for all videos
      lib.qsa("video").forEach((vid, i) => {
        vid.currentTime = 0;
        vid.muted = true;
        vid.pause();
      });
    } else {
    }
  },
};

export { Wistia as default };
